import styled, { Spacing, Breakpoint } from '@nfinite/react-hubstairs/styled'

export const SPACING_BOTTOM_PAGE = 200
export const SPACING_BOTTOM_PAGE_MOBILE = 250

export const Container = styled('div')`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const Main = styled('div')`
  position: relative;
  width: 100%;
  flex-grow: 1;
  ${Spacing.generatePadding({ top: 'm' })}
  padding-bottom: ${({ bottomSpacing }) => (bottomSpacing ? SPACING_BOTTOM_PAGE_MOBILE : 0)}px;
  ${Breakpoint.greaterThanMobile()} {
    padding-bottom: ${({ bottomSpacing }) => (bottomSpacing ? SPACING_BOTTOM_PAGE : 0)}px;
  }
`
